import { debounce } from "lodash-es";
import type { RefObject } from "react";
import { useCallback, useEffect, useMemo, useState } from "react";

import { useAdHeight } from "./useAdHeight";

/**
 * 自定义hook：计算菜单高度
 * 根据header和广告的高度动态计算菜单的高度和位置
 */
export function useMenuHeight(menuRef: RefObject<HTMLElement>) {
  const [menuHeight, setMenuHeight] = useState<string>("82vh");
  const adHeight = useAdHeight();

  const calcTop = useCallback(() => {
    let headerHeight = 0;
    const header = document.getElementById("header");
    if (header) headerHeight = header.getBoundingClientRect().height;

    const scrollY = window.scrollY;
    const scrollOffset = Math.min(scrollY, adHeight);

    if (menuRef.current) {
      menuRef.current.style.top = `${headerHeight + adHeight - scrollOffset}px`;
      setMenuHeight(
        `calc(100dvh - ${headerHeight + adHeight - scrollOffset}px)`,
      );
    }
  }, [adHeight, menuRef]);

  const debouncedCalcTop = useMemo(() => debounce(calcTop, 16), [calcTop]);

  useEffect(() => {
    // 初始计算
    calcTop();

    window.addEventListener("resize", calcTop);
    window.addEventListener("scroll", debouncedCalcTop);

    return () => {
      window.removeEventListener("resize", calcTop);
      window.removeEventListener("scroll", debouncedCalcTop);
    };
  }, [calcTop, debouncedCalcTop]);

  return menuHeight;
}
